import React from 'react';
import Form, { Field, useForm } from 'rc-field-form';
import { saveDeliverUserInfo } from 'lib/apis';
import toast from 'lib/utils/toast';
import { showModal } from 'lib/components/Modal';
import Dialog from 'lib/components/DialogV2';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import monitor from 'lib/utils/monitor';
import { GOODS_ERROR_MSG, COMMON_MSG } from 'lib/constants/error';
import { PrizeSource } from 'lib/constants/award';
import { awardPhysicalGift } from 'lib/apis/nodeApi';
import { showTipsDialog } from 'lib/components/TipsDialog';
import SaveAddressSuccess from './SaveAddressSuccess';
import './index.scss';

type FormValues = {
  name: string;
  tel: string;
  addr: string;
};

const AddressInput = ({
  actId,
  prizeSource,
  fusionPrizeRecordId,
  lotteryId,
  successCallback,
  saveUserInfo = saveDeliverUserInfo,
}) => {
  const [form] = useForm();

  const submitFail = (err) => {
    const errMsg = err.errorFields[0]?.errors[0];
    toast.info(errMsg);
  };

  // 表单提交
  const finishInputCallback = async (values: FormValues) => {
    const userInfo = JSON.stringify(values);
    toast.loading();
    let res;
    if (prizeSource === PrizeSource.FRAGMENT_FUSION) {
      res = await awardPhysicalGift({ fusionPrizeRecordId, addressInfo: userInfo });
    } else {
      res = await saveUserInfo({ actId, lotteryId, userInfo });
    }
    toast.close();
    if (res?.code !== 0) {
      report(ATTA_REPORT.LOTTERY_REACEIVE.SAVE_ADDRESS_FAIL, { prizeSource });
      monitor.reportLog({
        actionName: 'saveDeliverUserInfo failed',
      });
      showTipsDialog({
        content: GOODS_ERROR_MSG[res?.code] || COMMON_MSG,
      });
      return;
    }
    report(ATTA_REPORT.LOTTERY_REACEIVE.SAVE_ADDRESS_SUCCESS, { prizeSource });
    successCallback?.();
    showTipsDialog({
      title: '',
      content: SaveAddressSuccess,
      buttonText: '确认',
      onConfirm: () => {
        report(ATTA_REPORT.MULTIPLE_LOTTERY.LOTTERY_CLOSE_MODAL, { prizeSource });
      },
    });
  };

  return (
    <Dialog
      customClass="user-info-modal"
      keyboard={{ onEnter: () => form.submit() }}
      title={
        <div className="user-info__title">
          恭喜您获得奖品<br></br>请填写您的邮寄信息
        </div>
      }
    >
      <Form form={form} onFinish={finishInputCallback} onFinishFailed={submitFail}>
        <div className="user-info">
          <div className="user-info__item">
            <div className="user-info__item--title">收货人</div>
            <div className="user-info__item--picker">
              <Field
                name="name"
                rules={[
                  {
                    required: true,
                    message: '请输入收货人姓名',
                  },
                ]}
              >
                <input className="picker-list" type="text" placeholder="请输入收货人姓名"></input>
              </Field>
            </div>
          </div>
          <div className="user-info__item">
            <div className="user-info__item--title">手机号码</div>
            <div className="user-info__item--picker">
              <Field
                name="tel"
                rules={[
                  {
                    required: true,
                    message: '请输入手机号',
                  },
                  {
                    pattern: /^1[3456789]\d{9}$/,
                    message: '手机号格式不正确',
                  },
                ]}
              >
                <input className="picker-list" type="tel" placeholder="请输入手机号"></input>
              </Field>
            </div>
          </div>
          <div className="user-info__item">
            <div className="user-info__item--title">详细地址</div>
            <div className="user-info__item--picker">
              <Field
                name="addr"
                rules={[
                  {
                    required: true,
                    message: '请输入详细地址',
                  },
                ]}
              >
                <input className="picker-list" type="text" placeholder="请输入详细地址"></input>
              </Field>
            </div>
          </div>
          <div className="user-info__tips">我们会保护您的隐私，个人信息仅用于邮寄奖品</div>
        </div>
        <div className="user-info__footer">
          <div className="user-info__footer confirm-button" onClick={() => form.submit()}>
            提交
          </div>
        </div>
        <button type="submit" hidden style={{ visibility: 'hidden' }} />
      </Form>
    </Dialog>
  );
};

export const showOrderAddressInput = (addressInputParams) => showModal(<AddressInput {...addressInputParams} />);

export default AddressInput;
